import { getAccessToken, refreshAccessToken } from "../api/http";

const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8000";

export interface DownloadBlobParams {
  endpoint: string;
  filename: string;
  queryParams?: Record<string, string>;
}

export async function downloadBlob({
  endpoint,
  filename,
  queryParams = {},
}: DownloadBlobParams): Promise<void> {
  const qs = new URLSearchParams(queryParams).toString();
  const url = `${BASE_URL}${endpoint}${qs ? `?${qs}` : ""}`;

  const makeRequest = (token: string | null) =>
    fetch(url, {
      method: "GET",
      credentials: "include",
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });

  let token = getAccessToken();
  let response = await makeRequest(token);

  if (response.status === 401) {
    token = await refreshAccessToken();
    response = await makeRequest(token);
  }

  if (!response.ok) {
    throw new Error(`Export failed: ${response.status}`);
  }

  const disposition = response.headers.get("Content-Disposition");
  if (disposition) {
    const match = /filename="([^"]+)"/.exec(disposition);
    if (match) filename = match[1];
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(objectUrl);
}
